import React from "react";
import { Divider, PageHeaderContainer, Title, TitleContainer } from "../styled";
import styled from "styled-components";
import Navbar from "./Navbar";

const Container = styled.div`
  height: 100%;
`;

const PageHeader = ({ title }) => {
  return (
    <Container>
      <Navbar standAlone />
      <PageHeaderContainer>
        <TitleContainer>
          <Title>{title}</Title>
          <Divider />
        </TitleContainer>
      </PageHeaderContainer>
    </Container>
  );
};

export default PageHeader;
